import { Box } from "@mui/material";
import FlippyCard from "../FlippyCard";
import { useTranslation } from "react-i18next";
import {
  DriverScoreIcon,
  EventsIcon,
  MyTrypsNavIcon,
} from "../../../../common/Icons";
import {
  FLIPPY_CARD_DRIVER_SCORE,
  FLIPPY_CARD_EVENTS,
  FLIPPY_CARD_NUM_TRIPS,
} from "../../../../../constants/ids";

const StatCards = ({ flipLoading, flippyValues }) => {
  const { t } = useTranslation("Stats");

  const statsBoxStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    m: "2rem 0",
    width: "100%",
  };

  return (
    <Box sx={statsBoxStyle}>
      <FlippyCard
        isLoading={flipLoading}
        difference={flippyValues.avgEvents - flippyValues.lwEvents}
        iconSrc={<EventsIcon />}
        title={t("myAvgEvents")}
        frontDesc={t("daily")}
        backDesc={t("eventsDesc")}
        statLine={flippyValues.avgEvents}
        id={FLIPPY_CARD_EVENTS}
      />

      <FlippyCard
        isLoading={flipLoading}
        difference={flippyValues.avgDriverScore - flippyValues.lwDriverScore}
        iconSrc={<DriverScoreIcon />}
        title={t("avgDriverScore")}
        frontDesc={t("outOf100")}
        backDesc={t("avgDriverScoreDesc")}
        statLine={flippyValues.avgDriverScore}
        id={FLIPPY_CARD_DRIVER_SCORE}
      />

      <FlippyCard
        isLoading={flipLoading}
        iconSrc={<MyTrypsNavIcon />}
        title={t("tryps")}
        frontDesc={t("totalNumTryps")}
        backDesc={t("trypsDesc")}
        statLine={flippyValues.totalTryps}
        id={FLIPPY_CARD_NUM_TRIPS}
      />
    </Box>
  );
};

export default StatCards;
